import { ErrorMessage } from "@hookform/error-message";
import { Button, IconButton } from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import AuthContext from "../../../context/user-auth/AuthProvider";
import BlockLoader from "../../blockloader/BlockLoader";

function Newpassword(props) {
  const { updatePassword, isLoading, emailToResetPassword } = useContext(AuthContext);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showReSetPassword, setShowReSetPassword] = React.useState(false);
  const checkOtp = useRef(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));

  const {
    register,
    handleSubmit,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const handleVerification = async (data) => {
    const checkEmpty = otp.some((item) => item === "");
    checkOtp.current = checkEmpty ? true : false;

    if (!checkOtp.current && watch("confirm_password") === watch("password")) {
      const formData = {
        id: window.$userIdReset,
        otp: parseInt(otp.join("")),
        password: data.password,
      };
      const response = await updatePassword(formData);
      if (response.data.success) {
        props.onHide();
      }
    }
  };

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowReSetPassword = () => setShowReSetPassword((show) => !show);
  

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Modal {...props} backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered>
      {isLoading && <BlockLoader position="absolute" />}
      <Modal.Header closeButton body-text-variant="--bs-purple">
        <Modal.Title id="contained-modal-title-vcenter">
          <h3 className="mb-0">Verification Code</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please enter the verfication code that has been sent to your registered email address..</p>
        <Form onSubmit={handleSubmit(handleVerification)} className="new-pass">
          <div className="col text-center">
            {otp.map((data, index) => {
              return <input className="otp-field form-control" type="text" name="otp" maxLength="1" value={data} onChange={(e) => handleChange(e.target, index)} onFocus={(e) => e.target.select()} />;
            })}
            {checkOtp.current && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Please enter OTP
              </Form.Control.Feedback>
            )}
          </div>
          <div class="content d-flex frgtpwd_resendotp fz-12">
            <small class="me-1">Didn't get the code ?</small>{" "}
            <div role={"button"} id="resendOtp" class="text-decoration-none small fw-500 text-underline--dashed" style={{ color: "#dc3545" }} onClick={() => emailToResetPassword(window.$userEmailReset)}>
              Resend
            </div>
          </div>
          <Form.Group className="my-3">
            <Form.Label>New Password</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter New Password"
                {...register("password", {
                  required: "Enter your password",
                })}
              />
              <IconButton aria-label="toggle password visibility" className="position-absolute" tabIndex={-1} onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
              <ErrorMessage
                errors={errors}
                name="password"
                render={({ message }) => (
                  <Form.Control.Feedback type="invalid" className="d-block">
                    {message}
                  </Form.Control.Feedback>
                )}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group>
            <Form.Label>Confirm Password</Form.Label>
            <InputGroup>
            <Form.Control 
              type={showReSetPassword ? "text" : "password"} placeholder="Enter Password Again" {...register("confirm_password", { required: true })} />
            <IconButton aria-label="toggle password visibility" className="position-absolute" tabIndex={-1} onClick={handleClickShowReSetPassword} onMouseDown={handleMouseDownPassword} edge="end">
                {showReSetPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
            
            {watch("confirm_password") !== watch("password") && getValues("confirm_password") ? (
              <Form.Control.Feedback type="invalid" className="d-block">
                The password do not match
              </Form.Control.Feedback>
              ) : null}
            </InputGroup>
          </Form.Group>

          <Button variant="contained" color="error" className="mt-3 d-flex m-auto" type="submit">
            Submit
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default Newpassword;
